"use client";

// French copy of components/widgetHeroLight/widgetHeroLight.comp.tsx for the
// enriched hub layout (FR-1). Hub-only: no platform, no coming-soon, no
// quotes strip, no PostHog CTA-text experiment (the French button always shows
// the widget's French button text, so the English test stays clean).
import React, { useEffect } from "react";
import { StyledWidgetHeroLight } from "../widgetHeroLight/widgetHeroLight.styles";
import { IPlugin } from "../../types";
import { CustomLink } from "../link/link.comp";
import { trackEvent } from "@/lib/track";
import { ParallaxEditor } from "../parallax-editor/parallax-editor.comp";
import { CommonNinjaWidgetRenderer } from "../CommonNinjaWidgetRenderer/commonNinjaWidgetRenderer.comp";
import { createMobileAwareClickHandler } from "../../helpers/mobile-redirect";
import { HeaderFr } from "./headerFr.comp";
import { WidgetNavbarFr } from "./widgetNavbarFr.comp";
import { SocialProofFr } from "./socialProofFr.comp";

interface IWidgetHeroLightFrProps {
  widget: IPlugin;
  widgetImgSrc: string;
  heroTitle: string;
  showTemplatesTab?: boolean;
}

export const WidgetHeroLightFr = ({
  widget,
  widgetImgSrc,
  heroTitle,
  showTemplatesTab,
}: IWidgetHeroLightFrProps) => {
  useEffect(() => {
    trackEvent(`Enter App Page`, { serviceName: widget.serviceName, locale: "fr" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editorPath = `/${widget.slug}/editor`;

  return (
    <StyledWidgetHeroLight>
      <HeaderFr lightMode />
      <div className="navbar-wrapper">
        <WidgetNavbarFr widget={widget} showTemplatesTab={showTemplatesTab} />
      </div>
      <div className="hero-wrapper">
        <div className="hero-text-wrapper">
          <h1>{heroTitle}</h1>
          <h2>{widget.teaser}</h2>
          <div className="button-wrapper">
            <CustomLink
              variant="gradient"
              external
              title={widget.buttonText}
              className="try-button"
              id="main-create-widget-cta"
              href={editorPath}
              onClick={createMobileAwareClickHandler(() => {
                // Same event and payload as the English hero (DEV-15194), plus
                // locale, so French clicks add up with English ones.
                trackEvent("widget_hero_cta_click", {
                  widget: widget.slug,
                  serviceName: widget.serviceName,
                  platform: null,
                  cta_variant: "control",
                  locale: "fr",
                });
              }, editorPath)}
            >
              {widget.buttonText}
            </CustomLink>
            <SocialProofFr />
          </div>
          <p
            className="cn-editor-language-note"
            style={{ fontSize: 13, opacity: 0.75, margin: "10px 0 0" }}
          >
            {"L'éditeur est en anglais pour le moment. Sans carte bancaire."}
          </p>
        </div>
        <div className="hero-img-wrapper">
          <ParallaxEditor
            widgetImgSrc={widgetImgSrc}
            editorContainerImgSrc="https://website-assets.commoninja.com/distribution/widget-light-hero-editor.webp"
            wrapperStyle={{ overflow: "visible" }}
            style={{ width: "100%" }}
            widgetImgStyle={{ width: "805px", height: "auto", top: "10%", left: "-15%" }}
            editorContainerImgStyle={{ width: "770px", height: "620px", transform: "translate(-20%, 0)" }}
            contentImgStyle={{ top: "38%" }}
            skinsImgStyle={{ top: "17%", left: "78%" }}
            hideContentImg
            hideLayoutsImg
            hideSkinsImg
          />
        </div>
      </div>
      <CommonNinjaWidgetRenderer
        widgetId={"87cf32fd-d8c2-4a3b-8cfc-0f419c000fbf"}
        style={{ filter: "brightness(0)" }}
      />
    </StyledWidgetHeroLight>
  );
};
